<script setup lang="ts">
import { useAuth0 } from '@auth0/auth0-vue'

import PageHeader from '#shared/components/PageHeader.vue'

definePage({
  meta: { requiresAuth: true, title: 'Home' },
})

const { user } = useAuth0()
</script>

<template>
  <PageHeader title="Welcome">
    <template #description>
      Signed in as
      <span class="font-medium text-foreground">{{ user?.email }}</span>
    </template>
  </PageHeader>
</template>
